<div class="content">
  <div class="tip" (click)="isExpanded = !isExpanded">点击展开车票详情</div>

  <div class="tab-group">
    <div
      class="tab"
      (click)="changeStatus('Active')"
      [ngClass]="{ active: status === 'Active' }"
    >
      有效车票
    </div>
    <div
      class="tab"
      (click)="changeStatus('Expired')"
      [ngClass]="{ active: status === 'Expired' }"
    >
      无效车票
    </div>
    <div class="space"></div>
    <app-bus-seat-search
      [(ngModel)]="searchValue"
      (ngModelChange)="searchValueChange()"
    ></app-bus-seat-search>
  </div>
  <div class="tab-content">
    <app-bus-seat-ticket
      status="Active"
      [bus_id]="bus_id"
      [username]="username"
      *ngIf="status === 'Active'"
      [isExpanded]="isExpanded"
    ></app-bus-seat-ticket>
    <app-bus-seat-ticket
      status="Expired"
      *ngIf="status === 'Expired'"
      [bus_id]="bus_id"
      [username]="username"
      [isExpanded]="isExpanded"
    ></app-bus-seat-ticket>
  </div>
</div>
